/* eslint-disable import/prefer-default-export */
export const LOGICAL_GROUP_CHANNEL_CODE =
  process.env.NEXT_PUBLIC_LOGICAL_GROUP_CHANNEL_CODE || "PTN";

export const RETAIL_LOGICAL_GROUP_CHANNEL_CODE =
  process.env.NEXT_PUBLIC_RETAIL_LOGICAL_GROUP_CHANNEL_CODE;
